import LocationShow from "../components/location/LocationDetails";

export default [
  { name: 'LocationShow', path: '/location/show/:id', component:LocationShow, meta: { requiresAuth: true}},
]
